/* ============================================================
   Yummii — oprydning efter temaets sidebar-lås

   Temaets .site-overlay lægger sig hen over hele siden med 36 %
   sort og tager imod alle klik, så længe <body> har klassen
   sidebar-opened. Den klasse sættes og fjernes udelukkende af
   temaets egen <sidebar-drawer> i section-header.js.

   Butikken bruger den custom yy-cart i stedet for temaets
   kurv-skuffe, og de to kender ikke hinanden. Lukkes en skuffe ad
   en vej temaet ikke selv står for, bliver klassen hængende: der
   er ikke længere noget åbent, men skærmen forbliver mørk — og
   klikkene forsvinder ned i et lag man ikke kan se.

   Her håndhæver vi temaets egen regel: klassen hører kun hjemme
   så længe en skuffe faktisk er åben.

   Vi tester på _opened og ikke på klassen sidebar--opened, fordi
   show() først sætter den klasse 15 ms senere. _opened sættes
   synkront og før body-klassen, så observatøren aldrig når at se
   et ægte åbent panel som forældreløst.
   ============================================================ */
(function () {
  'use strict';

  var LAASEKLASSER = [
    'sidebar-opened',
    'sidebar-opened--left',
    'sidebar-opened--right'
  ];

  function skuffeAaben() {
    var skuffer = document.querySelectorAll('sidebar-drawer');
    for (var i = 0; i < skuffer.length; i++) {
      if (skuffer[i]._opened === true) return true;
    }
    return false;
  }

  function ryd() {
    if (!document.body.classList.contains('sidebar-opened')) return;
    if (skuffeAaben()) return;
    LAASEKLASSER.forEach(function (klasse) {
      document.body.classList.remove(klasse);
    });
  }

  /* At fjerne klassen udløser observatøren igen, men anden gang er
     klassen væk og ryd() falder fra på første linje. */
  new MutationObserver(ryd).observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

  ryd();
}());
